import { AnyAction } from 'redux';
import { Store } from 'store';
import { ThunkDispatch } from 'redux-thunk';
import getLastEncOrderItemId from 'store/product/selector/getLastEncOrderItemId';
import getLanguagePrefix from 'store/app/selector/getLanguagePrefix';

const redirectToApiEditorOperation =
  () => (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const routePath = '/designer';
    const lastOrderItemId = getLastEncOrderItemId(store);
    const langPrefix = getLanguagePrefix(store);

    window.location.href = `${langPrefix}${routePath}?order_item_id=${lastOrderItemId}&back_url=%2Fmy-cart`;
  };

export default redirectToApiEditorOperation;
